import useUserDetails from "@ch/helpers/hooks/useUserDetails";
import getGreeting from "@ch/helpers/utils/getGreeting";
import { AppointmentsRoutesEnum } from "@ch/router/ Appointments/enums";
import { MenuRoutesEnum } from "@ch/router/MenuRoutes/enums";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import UserAvatar from "../Avatar/UserAvatar";
import Button from "../Buttons/Button";

const Header: FC = () => {
  const navigate = useNavigate();
  const { user, lastNameInitial } = useUserDetails();

  return (
    <header className="px-4 pt-4 sm:px-8 sm:pt-6">
      <div className="flex flex-col-reverse gap-6 rounded-lg bg-white px-6 py-4 lg:flex-row lg:items-center lg:justify-end">
        {/* <div className="flex-1 max-w-xs">
          <TextInput
            leftIcon="search"
            placeholder="Search Here..."
            size="sm"
            type="search"
          />
        </div> */}
        <div className="flex items-center justify-end gap-6">
          <div className="flex items-center justify-end gap-2">
            <Button
              aria-label="calendar"
              className="rounded-lg bg-white-300"
              intent="ghost"
              leftIcon="calendar"
              onClick={() => {
                void navigate(AppointmentsRoutesEnum.ROOT);
              }}
              shape="icon"
              size="sm"
              variant="secondary"
            />
            <Button
              aria-label="settings"
              className="rounded-lg bg-white-300"
              intent="ghost"
              leftIcon="settings"
              onClick={() => {
                void navigate(MenuRoutesEnum.ROOT);
              }}
              shape="icon"
              size="sm"
              variant="secondary"
            />
          </div>
          <div className="flex justify-end">
            <button
              aria-label="user"
              className="btn-unstyled hover:ring-0"
              onClick={() => {
                void navigate(MenuRoutesEnum.ROOT);
              }}
              type="button"
            >
              <UserAvatar
                imageUrl={user?.image}
                status={user?.activeStatus}
                subtitle={`${getGreeting()}!`}
                title={`${user?.firstName} ${lastNameInitial}`}
              />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
